const styles = theme => ({
  cardTitle: {
    fontSize: '20px',
    fontWeight: 500,
    marginBottom: '26px',
    textAlign: 'center',
  },
})
export default styles
